import { UsageNameToCodeEnum } from '@ecm/portfolio';

export const routerTranslationFr = {
    ecm: {
        head: {
            title: {
                orange: '{{value}} - Espace client Orange',
                sosh: '{{value}} - Espace client Sosh',
            },
        },
        error: {
            default: {
                'nav-title': 'Service indisponible',
                title: 'L’espace client est indisponible pour le moment',
                description:
                    'Une erreur technique est survenue. Veuillez nous excuser pour la gêne occasionnée. Nous vous invitons à réessayer ultérieurement.',
            },
            unauthorized: {
                'nav-title': 'Session expirée',
                title: "Vous n'êtes pas identifié sur votre espace client",
                description:
                    'Afin de pouvoir continuer votre navigation, il est nécessaire de vous connecter à votre espace client.',
                'redirect-label': 'Se connecter à mon espace client',
                'redirect-url': 'https://login.orange.fr/?service=nextecare&return_url=',
            },
            'not-found': {
                'nav-title': 'Page indisponible',
                title: 'Page indisponible',
                description: 'La page demandée n’existe pas.',
            },
            action: {
                retry: 'Réessayer',
                home: "Retourner à l'accueil",
            },
        },
        selector: {
            contract: {
                homepageLinkLabel: "Accueil de l'espace client",
                title: "Choisissez l'offre que vous souhaitez gérer",
                internet: {
                    actif: {
                        icon: 'icon-livebox',
                        label: 'Offre internet',
                        desc: ['{{lineNumber}}', '{{offerName}}', '{{cityName}}'],
                    },
                    clos: {
                        icon: 'icon-contrat-resilie',
                        label: 'Ancienne offre internet',
                        desc: '{{lineNumber}}',
                    },
                },
                '4ghome': {
                    actif: {
                        icon: 'icon-WiFi-Home',
                        label: 'Offre internet',
                        desc: '{{offerName}}',
                    },
                    clos: {
                        icon: 'icon-contrat-resilie',
                        label: 'Ancienne offre internet',
                        desc: '',
                    },
                },
                homelive: {
                    actif: {
                        icon: 'icon-Homelive',
                        label: 'Offre Homelive',
                        desc: '{{offerName}}',
                    },
                    clos: {
                        icon: 'icon-contrat-resilie',
                        label: 'Ancienne offre Homelive',
                        desc: '',
                    },
                },
                airbox: {
                    actif: {
                        icon: 'icon-Airbox',
                        label: 'Offre Airbox',
                        desc: '{{offerName}}',
                    },
                    clos: {
                        icon: 'icon-contrat-resilie',
                        label: 'Ancienne offre Airbox',
                        desc: '',
                    },
                },
                parnasse: {
                    actif: {
                        icon: 'icon-parnasse',
                        label: 'Contrat Parnasse',
                        desc: '{{offerName}}',
                    },
                },
                fixe: {
                    actif: {
                        icon: 'icon-device-fixed-line-phone',
                        label: 'Ligne fixe',
                        desc: ['{{lineNumber}}', '{{offerName}}'],
                    },
                    clos: {
                        icon: 'icon-contrat-resilie',
                        label: 'Ancienne ligne fixe',
                        desc: '{{lineNumber}}',
                    },
                },
                mobile: {
                    actif: {
                        icon: 'icon-device-smart-phone',
                        label: 'Forfait mobile',
                        desc: ['{{lineNumber}}', '{{offerName}}'],
                    },
                    clos: {
                        icon: 'icon-contrat-resilie',
                        label: 'Ancien forfait mobile',
                        desc: '{{lineNumber}}',
                    },
                },
                open: {
                    actif: {
                        icon: 'icon-pack-internet-mobile',
                        label: 'Pack Internet + Mobile',
                        desc: ['{{lineNumber}}', '{{offerName}}', '{{cityName}}'],
                    },
                    clos: {
                        icon: 'icon-contrat-resilie',
                        label: 'Ancien pack Internet + Mobile',
                        desc: '{{lineNumber}}',
                    },
                },
                'maison-protegee': {
                    actif: {
                        icon: 'icon-maison-protegee',
                        label: 'Offre Maison Protégée',
                        desc: '{{offerName}}',
                    },
                    clos: {
                        icon: 'icon-contrat-resilie',
                        label: 'Ancienne offre Maison Protégée',
                        desc: '',
                    },
                },
                'maison-protegee-v2': {
                    actif: {
                        icon: 'icon-maison-protegee-v2',
                        label: 'Offre Orange Maison Protégée',
                        desc: '{{offerName}}',
                    },
                    clos: {
                        icon: 'icon-contrat-resilie',
                        label: 'Ancienne offre Orange Maison Protégée',
                        desc: '',
                    },
                },
                generic: {
                    actif: {
                        icon: 'icon-generic-document',
                        label: '{{offerName}}',
                        desc: '',
                    },
                    clos: {
                        icon: 'icon-contrat-resilie',
                        label: '{{offerName}}',
                        desc: '',
                    },
                },
            },
            usage: {
                title: "Choisissez l'équipement que vous souhaitez gérer",
                [UsageNameToCodeEnum.livebox]: {
                    icon: 'icon-livebox-box',
                    label: 'Internet',
                    desc: ['{{usageModel}}', '{{cityName}}'],
                },
                [UsageNameToCodeEnum.tv]: {
                    icon: 'icon-decoder',
                    label: {
                        primary: 'Décodeur TV',
                        secondary: 'Second décodeur TV',
                    },
                    desc: ['{{usageModel}}', '{{cityName}}'],
                },
                [UsageNameToCodeEnum.tvStick]: {
                    icon: 'icon-La-Cle',
                    label: {
                        default: 'Clé TV',
                        personalized: 'Clé TV de {{name}}',
                    },
                    desc: '',
                },
                [UsageNameToCodeEnum.mobile]: {
                    icon: 'icon-device-smart-phone',
                    label: {
                        personalized: 'Mobile de {{name}}',
                        default: 'Mobile',
                    },
                    desc: ['{{lineNumber}}', '{{usageBrand}} {{usageModel}}'],
                },
                [UsageNameToCodeEnum.homelive]: {
                    icon: 'icon-Homelive',
                    label: 'Homelive',
                    desc: '{{cityName}}',
                },
                [UsageNameToCodeEnum.sim]: {
                    icon: 'icon-sim',
                    label: {
                        default: 'Clé internet / tablette',
                        personalized: 'Clé internet / tablette de {{name}}',
                    },
                    desc: '{{usageModel}}',
                },
                [UsageNameToCodeEnum.eMultiSim]: {
                    icon: 'icon-SIM-E-Multi',
                    label: {
                        default: 'Multi-SIM Appels et Internet',
                        personalized: 'Multi-SIM Appels et Internet de {{name}}',
                    },
                    desc: '{{usageModel}}',
                },
                [UsageNameToCodeEnum.multiSimI]: {
                    icon: 'icon-multi-sim',
                    label: {
                        default: 'Multi-SIM Internet',
                        personalized: 'Multi-SIM Internet de {{name}}',
                    },
                    desc: '{{usageModel}}',
                },
                [UsageNameToCodeEnum.multiSimIA]: {
                    icon: 'icon-multi-sim',
                    label: {
                        default: 'Multi-SIM Appels et Internet',
                        personalized: 'Multi-SIM Appels et Internet de {{name}}',
                    },
                    desc: '{{usageModel}}',
                },
                [UsageNameToCodeEnum.airbox]: {
                    icon: 'icon-Airbox',
                    label: {
                        default: 'Airbox',
                        personalized: 'Airbox de {{name}}',
                    },
                    desc: '{{lineNumber}}',
                },
                [UsageNameToCodeEnum.flybox]: {
                    icon: 'icon-Flybox',
                    label: 'Flybox',
                    desc: '{{cityName}}',
                },
                [UsageNameToCodeEnum.smartWatch]: {
                    icon: 'icon-smart-watch',
                    label: {
                        personalized: 'Montre connectée de {{name}}',
                        default: 'Montre connectée',
                    },
                    desc: '{{usageBrand}} {{usageModel}}',
                },
                [UsageNameToCodeEnum.Landline]: {
                    icon: 'icon-device-fixed-line-phone',
                    label: 'Fixe',
                    desc: ['{{lineNumber}}', '{{cityName}}'],
                },
                [UsageNameToCodeEnum.LandlinePrincipal]: {
                    icon: 'icon-device-fixed-line-phone',
                    label: 'Fixe',
                    desc: ['{{lineNumber}}', '{{cityName}}'],
                },
                [UsageNameToCodeEnum.LandlineCorps]: {
                    icon: 'icon-device-fixed-line-phone',
                    label: 'Fixe',
                    desc: ['{{lineNumber}}', '{{cityName}}'],
                },
                [UsageNameToCodeEnum.voipSip]: {
                    icon: 'icon-device-fixed-line-phone',
                    label: 'Fixe',
                    desc: ['{{lineNumber}}', '{{cityName}}'],
                },
                [UsageNameToCodeEnum.voipH323]: {
                    icon: 'icon-device-fixed-line-phone',
                    label: 'Fixe',
                    desc: ['{{lineNumber}}', '{{cityName}}'],
                },
                [UsageNameToCodeEnum.voipLandline]: {
                    icon: 'icon-device-fixed-line-phone',
                    label: 'Fixe',
                    desc: ['{{lineNumber}}', '{{cityName}}'],
                },
            },
            universe: {
                orange: {
                    title: 'Gérer sur Orange.fr',
                },
                sosh: {
                    title: 'Gérer sur Sosh.fr',
                },
            },
            rebound: {
                title: {
                    selecteur_contrat: "Votre contrat n'apparait pas ?",
                    selecteur_usage: 'Consulter un autre équipement',
                },
                links: [
                    {
                        icon: 'icon-add-more',
                        label: 'Rattacher un contrat dans votre espace client',
                        link: {
                            references: [
                                {
                                    linkWeb: {
                                        browser: 'https://espace-client.orange.fr/rattacher-un-contrat',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        icon: 'icon-avatar',
                        label: 'Identifiez-vous avec le compte du contrat concerné',
                        link: {
                            references: [
                                {
                                    linkWeb: {
                                        browser: 'https://login.orange.fr?service=&url={{currentLink}}',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
            error: {
                unavailable: {
                    title: 'La fonction demandée n’est pas disponible pour les contrats de votre espace client',
                },
            },
        },
    },
};
